import { render, staticRenderFns } from "./AdministratorsComponent.vue?vue&type=template&id=0ff9b671&scoped=true&"
import script from "./AdministratorsComponent.vue?vue&type=script&lang=js&"
export * from "./AdministratorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorsComponent.vue?vue&type=style&index=0&id=0ff9b671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9b671",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressLinear})
